import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import Loader from "../../../components/Loader/Loader";
import { resolveOnChange } from "antd/es/input/Input";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import MDEditor from "@mdfe/ckeditor5-custom-build";
import translations from "@mdfe/ckeditor5-custom-build/build/translations/en";
import { Flag } from "feather-icons-react/build/IconComponents";
import { TagsInput } from "react-tag-input-component";

const ManageEmailTemplates = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const [editordata, setEditorData] = useState("");
  const [loading, setLoading] = useState(false);

  // formvalues
  const [formValues, setFormValues] = useState({
    EmailTemplates: "",
    EmailSubjects: "",
    BodyHtml: "",
    IsActive: false,
  });

  const [ccMailTo, setCcMailTo ] = useState([])

  // validation schema
  const validationSchema = Yup.object().shape({
    EmailTemplates: Yup.string().required("EmailTemplates is Required"),
    EmailSubjects: Yup.string().required("EmailSubjects is Required"),
    // BodyHtml: Yup.string().required("BodyHtml is Required"),
  });

  // Styles
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }), // dropdown menu css
  // };

  // Post Data
  const handleSubmit = (values) => {
    setLoading(true);

    let emailtemplatedata = {
      id: paramObject.id || 0,

      emailtemplates: values.EmailTemplates,
      emailsubject: values.EmailSubjects,
      bodyhtml: editordata,
      isactive: values.IsActive,
      loginuserid: Id,
      EmailCC : ccMailTo?.join(',')
    };
    console.log(emailtemplatedata, "emailtemplatedata 123");
    console.log(formValues, "formValue 123");

    axios
      .post(`${config.generalBaseUrl}/generals/upsert`, emailtemplatedata, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/email-templates");
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        );
        setLoading(false);
      })
      .catch((error) => {
        console.log("error occured", error);
        setLoading(false);
      });
  };


  const handleCCMail = (event) =>{
   console.log(event, "ccmailto") 
   setCcMailTo(event)
  }

  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.generalBaseUrl}/generals/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData);

          const emailtemplatedata = res.data.ResponseData[0];

          const data = {
            EmailTemplates: emailtemplatedata.EmailTemplates,
            EmailSubjects: emailtemplatedata.EmailSubject,
            EmailCC: emailtemplatedata.EmailCC,
            BodyHtml: emailtemplatedata.BodyHtml,
            IsActive: emailtemplatedata.IsActive === 1 ? true : false,
          };

          setEditorData(data.BodyHtml);
          setFormValues(data);
          setCcMailTo(data?.EmailCC ? data?.EmailCC?.split(',') : [])

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
    }
  }, []);

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Email Templates</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/email-templates">Email Templates List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Manage Email Templates
                </li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Manage Email Templates</h5>
            </div>
            <Formik
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    {/* row1 */}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 form-label">
                            Email Templates
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${
                                errors.EmailTemplates ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="EmailTemplates"
                              name="EmailTemplates"
                            />
                            <div className="invalid-feedback">
                              {touched.EmailTemplates && errors.EmailTemplates
                                ? errors.EmailTemplates
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 form-label">
                            Email Subjects{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${
                                errors.EmailSubjects ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="EmailSubjects"
                              name="EmailSubjects"
                            />
                            <div className="invalid-feedback">
                              {touched.EmailSubjects && errors.EmailSubjects
                                ? errors.EmailSubjects
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 form-label">
                            CC Mail: <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <TagsInput
                              type="text"
                              placeHolder="Press Enter to Add"
                              name="ccEmail"
                              id="rti--tag"
                              style={{ width: "1000px !important" }}
                              value={ccMailTo}
                              onChange={(evnt) =>
                                handleCCMail(evnt)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="col-sm-6">
                            <div className="form-group row">
                              <label className="col-form-label col-md-3 form-label">
                                Is Active
                                <span className="text-danger">*</span>
                              </label>
                              <div className="col-md-9">
                                <div className="col-md-2">
                                  <Field
                                    className="form-check-input"
                                    style={{
                                      width: "1.25em",
                                      height: "1.25em",
                                    }}
                                    type="checkbox"
                                    id="IsActive"
                                    name="IsActive"
                                    onChange={handleChange}
                                    // onInput={handleSelectReceiveStocksalerts}
                                  />
                                </div>
                              </div>
                            </div>
                            <p>
                            <strong>Note: </strong>Please do not edit the text between the forward <span style={{color:'var(--error-main-color)', fontWeight:"bold"}}>#</span> and backward <span style={{color:'var(--error-main-color)', fontWeight:"bold"}}>#</span>. Altering this text will affect the dynamic mail content and may prevent the dynamic content from being properly fetched in the email.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* row 2 */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="BodyHTML">Body</label>

                          <CKEditor
                            id="BodyHtml"
                            name="BodyHtml"
                            editor={MDEditor}
                            data={editordata}
                            config={{
                              language: { ui: "en" },
                              toolbar: {
                                items: [
                                  "undo",
                                  "redo",
                                  "removeFormat",
                                  "|",
                                  "sourceEditing",
                                  "|",
                                  "fontFamily",
                                  "fontSize",
                                  "fontColor",
                                  "highlight",
                                  "|",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "|",
                                  "bulletedList",
                                  "numberedList",
                                  "todoList",
                                  "|",
                                  "alignment",
                                  "indent",
                                  "outdent",
                                  "|",
                                  "blockQuote",
                                  "link",
                                  "code",
                                  "imageUpload",
                                  "mediaEmbed",
                                  "insertTable",
                                ],
                              },
                              fontFamily: {
                                options: [
                                  "default",
                                  "Arial, Helvetica, sans-serif",
                                  "Courier New, Courier, monospace",
                                  "Georgia, serif",
                                  "Lucida Sans Unicode, Lucida Grande, sans-serif",
                                  "Tahoma, Geneva, sans-serif",
                                  "Times New Roman, Times, serif",
                                  "Trebuchet MS, Helvetica, sans-serif",
                                  "Verdana, Geneva, sans-serif",
                                ],
                              },
                              htmlSupport: {
                                allow: [
                                  {
                                    name: /.*/,
                                    attributes: true,
                                    classes: true,
                                    styles: true,
                                  },
                                ],
                              },

                              // language: 'en'
                            }}
                            onReady={(editor) => {
                              // You can store the "editor" and use when it is needed.
                              // console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setEditorData(data);
                              console.log({ event, editor, data });
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* button */}
                    <div>
                      <div className="pull-right">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-3 me-3"
                        >
                          Save
                        </button>
                        <Link
                          to="/email-templates"
                          className="btn btn-sm btn-secondary mb-3 "
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageEmailTemplates;
